Bingo.Tutorials = {};

Bingo.Tutorials.init = (baseUrl) => {
    $('[data-fancybox][data-fancybox-url]').fancybox({
        idleTime: false,
        beforeShow(instance, slide) {
            const videoUrl = slide.opts.$orig.data('fancybox-url');
            window.history.pushState(null, null, videoUrl);
        },
        beforeClose() {
            window.history.pushState(null, null, baseUrl);
        },
    });
};

Bingo.Tutorials.open = (tutorial) => {
    $(`[data-fancybox-url="${tutorial}"]`).first().click();
};
